import React from 'react'
import { v4 as id } from 'uuid'

import Header from '../../../Components/Header'
import CoreContent from '../../../Components/CoreContent'

import Module from '../module'

function Core() {
    return (
        <div>
            <Header text={"General Rules"} />

            {Module.Pages.map(({ Name, Path, Description }) => <CoreContent key={id()} name={Name} content={Description} link={Module.Core + Path} />)}
        </div>
    )
}

export default Core